import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Silvina G. - Córdoba',
  text: 'Nunca pensé que con maíz pisingallo se podía ganar tanto. La calculadora de costos me abrió los ojos.',
  accent: 'border-palomitas-coral',
  quoteBg: 'bg-palomitas-coral'
}, {
  name: 'Romina A. - Lanús',
  text: 'Lo hago mientras mis nenes duermen. Es rápido y la ganancia es limpia.',
  accent: 'border-palomitas-pink',
  quoteBg: 'bg-palomitas-pink'
}, {
  name: 'Beatriz L. - Mendoza',
  text: 'El sabor Caramelo Salado es un vicio. Mis clientes me compran de a 3 frascos. ¡Recuperé la inversión en 2 días!',
  accent: 'border-palomitas-emerald',
  quoteBg: 'bg-palomitas-emerald'
}, {
  name: 'Carla D. - Santa Fe',
  text: 'Los guiones de venta son geniales. Cerré un pedido para un cumple de 80 personas gracias a saber qué decir.',
  accent: 'border-palomitas-purple',
  quoteBg: 'bg-palomitas-purple'
}];
export function Testimonials() {
  return <section className="py-20 bg-palomitas-cream relative overflow-hidden" data-id="element-277">
      <div className="absolute top-20 right-0 w-80 h-80 bg-palomitas-purple/5 rounded-full blur-3xl" data-id="element-278"></div>

      <div className="container px-4 mx-auto max-w-6xl relative z-10" data-id="element-279">
        <div className="text-center mb-16" data-id="element-280">
          <span className="inline-block bg-palomitas-gold/20 text-palomitas-brown px-5 py-2 rounded-full font-bold text-sm uppercase tracking-wide mb-4" data-id="element-281">
            ⭐ Testimonios
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-palomitas-brown mb-4" data-id="element-282">
            Historias reales, ingresos reales
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-283">
          {testimonials.map((testimonio, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white p-8 rounded-2xl shadow-lg border-l-4 ${testimonio.accent} relative`} data-id="element-284">
              <div className={`absolute -top-3 -left-3 ${testimonio.quoteBg} text-white w-10 h-10 rounded-full flex items-center justify-center shadow-lg`} data-id="element-285">
                <Quote size={18} data-id="element-286" />
              </div>
              <div className="flex gap-1 text-palomitas-gold mb-4 mt-2" data-id="element-287">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="currentColor" data-id="element-288" />)}
              </div>
              <p className="text-gray-700 text-lg italic mb-6" data-id="element-289">
                "{testimonio.text}"
              </p>
              <p className="font-bold text-palomitas-brown" data-id="element-290">
                {testimonio.name}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto rounded-3xl overflow-hidden shadow-2xl border-4 border-palomitas-gold/20" data-id="element-291">
          <img src="https://cdn.magicpatterns.com/uploads/u65mRHhLB3dDW54Uox85Nz/WhatsApp_Image_2026-04-30_at_02.13.34.jpg" alt="Fotos de alumnas y sus productos" className="w-full h-auto object-cover" data-id="element-292" />
        </motion.div>
      </div>
    </section>;
}